module.exports = new __parcel__URL__("chartBoxOutline.562274ef.png").toString();